import { stringify } from 'qs'
import { useCustomSWR } from 'utils/hooks/fetchers'
import RequestCore, { lsGetWithToken } from 'utils/request'

export const useCatalogsVendorListings = (props = { limit: 999 }) => {
  const genUrl = () =>
    RequestCore.getToken()
      ? [`/catalogs/vendorListings?${stringify(props)}`, RequestCore.getToken()]
      : `/catalogs/vendorListings?${stringify(props)}`

  return useCustomSWR(genUrl, lsGetWithToken)
}
